module.exports = __webpack_public_path__ + "static/media/GettyImages-683364764_crop.771af46e.png";